<template>
  <div class="w-full">
    <NText weight="medium" variant="caption1">
      {{ t('deposit.cancelDirectDebitMessage') }}
    </NText>

    <div class="flex mt-4 mb-3">
      <NButton
        color="gray"
        variant="flat"
        class="ml-3 w-[calc(50%-12px)]"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <a
        v-gid="{
          module: 'cash',
          screen: 'home',
          section: 'cancelDirectDebitDialog',
          component: `cancelButton`,
        }"
        :href="EDIT_DIRECT_DEBIT_LINK"
        class="mr-3 w-[calc(50%-12px)] bg-critical-primary rounded-md"
      >
        <NButton color="red" class="w-full">
          {{ t('misc.disabled') }}
        </NButton>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';
import { computed } from 'vue';

type CancelDirectDebitDialogPropsType = {
  directDebitId: string;
};

const props = defineProps<CancelDirectDebitDialogPropsType>();

const { t } = useI18n();

const { remove } = useDialog();

let farabiAccountUrl = import.meta.env.VITE_APP_FARABI_ACCOUNT_URL;
const EDIT_DIRECT_DEBIT_LINK = computed(
  () =>
    `${farabiAccountUrl}profile?item=directDebitContractDetail&uid=${props.directDebitId}`
);
</script>
